export const pageLimits = [5, 10, 20, 40, 100];
export const defaultPageLimit = 10;
